import axios from "axios";
import React, { useState, useEffect, useMemo, useCallback } from "react";
import Switch from "react-switch";
import { ADMIN_USERS } from "../../../services/constants";
import { ZustandStore } from "../../../store/zustand-store";
import CustomTable from "../../../Mycomponent/share/customTable";
import {
  GET_ALLSERVICES,
  GET_RESUMERANKTRACKING,
  POST_SERVICES,
  PUT_SERVICES,
} from "../../utils/services";

import InputNumber from "@semcore/input-number";
import { useDeleteConfirmationModalStore } from "../../../store/useDeleteConfirmationModalStore";
import AddProjectStore from "../../../store/AddProjectStore";

import CheckM from "@semcore/icon/Check/m";
import CloseM from "@semcore/icon/Close/m";
import Button from "@semcore/ui/button";

const UserServices = () => {
  const { isAdminPerformAction } = ZustandStore((state) => state);
  const [page, setPage] = React.useState(1);
  const [isDisabled, setIsDisabled] = useState({
    disable: false,
    disableFor: null,
  });
  const [Users, setUsers] = useState({
    loading: true,
    error: false,
    data: [],
  });
  const { closeDeleteModal, setDeleteModalLoading, openDeleteModal } =
    useDeleteConfirmationModalStore((state) => state);

  const { showNotification } = AddProjectStore((state) => state);

  const fetchAdmin_users = async () => {
    try {
      const response = await axios.get(ADMIN_USERS());
      const response2 = await axios.get(GET_ALLSERVICES());
      const adminUsers = response.data.reverse(); // Assuming this is an array
      const services = response2.data;
      // Create a map for quick lookup
      const serviceMap = new Map(services.map((item) => [item.email, item]));
      // Merge the data
      const mergedData = adminUsers
        .map((user) => {
          if (user.user_type === "individual") {
            const service = serviceMap.get(user.email);
            return {
              ...user,
              ...(service ? { services: service } : {}),
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setUsers({ loading: false, error: false, data: mergedData });
    } catch (error) {
      console.error("Error fetching admin users or services", error);
      setUsers({ loading: false, error: true, data: [] });
    }
  };

  useEffect(() => {
    fetchAdmin_users();
  }, []);

  const handleResumeKeyword = async (email) => {
    setDeleteModalLoading(true);
    try {
      const response = await axios.get(GET_RESUMERANKTRACKING(email));
      showNotification({
        message: "Resume keyword tracking started",
        severity: "success",
      });
      closeDeleteModal();
    } catch (error) {
      console.error("Error updating user keyword rank", error);
    } finally {
      setIsDisabled({
        disable: false,
        disableFor: null,
      });
      setDeleteModalLoading(false);
    }
  };

  const handleUserKeywordRankUpdate = async (user) => {
    if (!user.email) return;
    openDeleteModal({
      buttonText: "Resume",
      message: `Resume keyword tracking for this user (${user.email})`,
      onConfirm: () => handleResumeKeyword(user.email),
    });
  };

  const SwitchComponent = ({ type, user, checkedValue }) => {
    const [value, setValue] = useState(user?.services?.site_audit_limit || 0);
    const isServices = user.services;
    const curr_value = user?.services?.site_audit_limit || 0;
    let payload = {
      email: user.email,
      site_audit: isServices?.site_audit || "False",
      site_audit_limit: value,
      block: isServices?.block || "False",
    };

    const handleServiceOperation = async () => {
      try {
        let response;
        if (isServices && isServices.id) {
          response = await axios.put(PUT_SERVICES(isServices.id), payload);
        } else {
          response = await axios.post(POST_SERVICES(), payload);
        }
        await fetchAdmin_users();
        showNotification({
          message: "Service operation successful",
          severity: "success",
        });
      } catch (error) {
        console.error("Error in handleAdd:", error.message);
        showNotification({
          message: "Failed to save service. Please try again.",
          severity: "error",
        });
      } finally {
        setIsDisabled({
          disable: false,
          disableFor: null,
        });
      }
    };

    const handleOnChange = useCallback(
      (limit_value, btnType) => {
        if (!type || !user?.email) return;

        switch (type) {
          case "site_audit": {
            if (btnType === "BTN") {
              payload.site_audit_limit = Number(limit_value);
            } else {
              payload.site_audit = !checkedValue ? "True" : "False";
              payload.site_audit_limit = Number(limit_value);
            }
            break;
          }
          case "block_account":
            payload.block = !checkedValue ? "True" : "False";
            break;
          default:
            break;
        }

        setIsDisabled({
          disable: true,
          disableFor: user.email,
        });
        if (type === "rank_tracking") {
          handleUserKeywordRankUpdate(user);
        } else {
          handleServiceOperation();
        }
      },
      [type, user, isAdminPerformAction]
    );

    return (
      <div className="d-flex align-items-center justify-content-center">
        {type === "rank_tracking" ? (
          <button
            onClick={handleOnChange}
            disabled={
              isDisabled.disable && isDisabled.disableFor === user.email
            }
          >
            Resume Rank-Tracking
          </button>
        ) : (
          <>
            <Switch
              className="react-switch"
              onColor="#3183FF"
              onChange={(e) => handleOnChange(value, "SWITCH")}
              checked={checkedValue}
              aria-labelledby="neat-label"
              uncheckedIcon={false}
              checkedIcon={false}
              width={40}
              height={20}
              disabled={
                isDisabled.disable && isDisabled.disableFor === user.email
              }
            />
            {type === "site_audit" && (
              <>
                <InputNumber w={100} ml={2}>
                  <InputNumber.Value
                    value={value}
                    onChange={setValue}
                    placeholder={"site-audit"}
                  />
                  <InputNumber.Controls />
                </InputNumber>
                {value !== curr_value ? (
                  <>
                    <Button
                      title="Clear"
                      onClick={() => handleOnChange(0, "BTN")}
                      mx={2}
                    >
                      <Button.Addon>
                        <CloseM />
                      </Button.Addon>
                    </Button>
                    <Button
                      title="Submit"
                      onClick={() => handleOnChange(value, "BTN")}
                    >
                      <Button.Addon>
                        <CheckM />
                      </Button.Addon>
                    </Button>
                  </>
                ) : null}
              </>
            )}
          </>
        )}
      </div>
    );
  };

  const tableHeader = useMemo(() => {
    return [
      {
        label: "E-MAIL",
        key: "email",
        minWidth: 200,
        align: "left",
      },
      {
        label: "Site-Audit Resume",
        key: "site_audit",
        minWidth: 200,
        align: "center",
      },
      {
        label: "Rank-Tracking Resume",
        key: "rank_tracking",
        minWidth: 200,
        align: "center",
      },
      {
        label: "Block Account",
        key: "block_account",
        minWidth: 200,
        align: "center",
      },
    ];
  }, []);

  const tableData = useMemo(() => {
    if (Users.data?.length === 0) return [];
    return Users.data?.map((user) => {
      return {
        id: user?.services?.id || user.id,
        email: user.email,
        site_audit: (
          <SwitchComponent
            key={user.email}
            user={user}
            type="site_audit"
            checkedValue={user?.services?.site_audit === "True" ? true : false}
          />
        ),
        rank_tracking: (
          <SwitchComponent
            user={user}
            key={user.email}
            type="rank_tracking"
            checkedValue={user?.services?.block === "True" ? true : false}
          />
        ),
        block_account: (
          <SwitchComponent
            user={user}
            key={user.email}
            type="block_account"
            checkedValue={user?.services?.block === "True" ? true : false}
          />
        ),
      };
    });
  }, [Users.data, isDisabled]);

  return (
    <>
      <CustomTable
        showSearchBar={true}
        type="user_list"
        rows={tableData}
        page={page}
        setPage={setPage}
        tableHeader={tableHeader}
        dataLoader={Users.loading}
        tableTitle={"Users Services"}
      />
    </>
  );
};

export default UserServices;
